import classNames from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import { Schema } from '@/entities/schema';

type Props = React.HTMLAttributes<HTMLUListElement> & {
    schemas: Schema[];
    activeSchemaIndex: number;
    setActiveSchemaIndex: Dispatch<SetStateAction<number>>;
};

const SchemaSwitcher = ({ schemas, activeSchemaIndex, setActiveSchemaIndex, ...props }: Props) => {
    return (
        <ul {...props} className={classNames('list-unstyled text-xs schema-list', props.className)}>
            {schemas.map((schema, i) => (
                <li key={i} className="schema-list__item">
                    <button
                        onClick={() => setActiveSchemaIndex(i)}
                        className={classNames('anchor-item schema-list-btn', {
                            'is-active': activeSchemaIndex === i,
                        })}
                    >
                        {schema.name}
                    </button>
                </li>
            ))}
        </ul>
    );
};

export default SchemaSwitcher;
